"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Common separator used to join values into a callback string ID in the Storefront,
// then this will be used again in Gateway to split the callback ID into values.
var SEPARATOR = '-';
exports.default = {
    SEPARATOR: SEPARATOR,
};
